module.exports = __webpack_public_path__ + "img/playwork oval 47.d5710c1f.svg";